import Button from "@pathwright/ui/src/components/button/Button"
import Text from "@pathwright/ui/src/components/ui/Text"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

const DeleteConfirmationUI = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
`

// Wrap this around content that will be replaced by a confirmation
const Removable = (props) => {
  const {
    onRemove,
    style,
    fontSize,
    wrapperComponent,
    confirmationMessage,
    children
  } = props

  const [removing, setRemoving] = React.useState(false)

  const handleRequestRemove = () => setRemoving(true)

  const handleCancelRemove = (event) => {
    event.preventDefault()
    event.stopPropagation()
    setRemoving(false)
  }

  const handleConfirmRemove = (event) => {
    event.preventDefault()
    event.stopPropagation() // Don't activate AccorianUI's onClick
    setRemoving(false)
    onRemove()
  }

  const Wrapper = wrapperComponent || DeleteConfirmationUI

  if (removing) {
    return (
      <Wrapper style={style}>
        <Text.Body
          style={{
            display: "inline-block",
            marginRight: "1rem",
            fontSize: fontSize || "1em"
          }}
        >
          {confirmationMessage}
        </Text.Body>
        <Button
          style={{
            padding: 0,
            marginRight: "15px",
            fontWeight: 600,
            fontSize: fontSize || "1em"
          }}
          styleType="blank"
          color="red"
          onClick={handleConfirmRemove}
        >
          Delete
        </Button>
        <Button
          style={{ padding: 0, fontWeight: 600, fontSize: fontSize || "1em" }}
          styleType="blank"
          color="black"
          onClick={handleCancelRemove}
        >
          Cancel
        </Button>
      </Wrapper>
    )
  }

  return children({ onRequestRemove: handleRequestRemove })
}

Removable.propTypes = {
  onRemove: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired,
  style: PropTypes.object,
  wrapperComponent: PropTypes.func,
  confirmationMessage: PropTypes.string
}

Removable.defaultProps = {
  confirmationMessage: "Are you sure?"
}

export default Removable
